module.exports = __webpack_public_path__ + "img/btn_home_taiwan.1edbadd9.png";